import { NotifyHelper } from "../../../helpers/toast";
import { eDangKyHoActionsObj } from "../../action-types/dang-ky-ho/IDangKyHoActionTypes"
import { generateActions, generateActionForKey } from "../generateActions"

export const dangKyHoActions = {
    ...generateActions(eDangKyHoActionsObj, "DANG_KY_HO"),
    ...generateActionForKey(
        eDangKyHoActionsObj,
        "DANG_KY_HO",
        "CAPNHAT_CHUYENNGANH2_SUCCESS",
        () => {
            NotifyHelper.Success("Cập nhật chuyên ngành 2 thành công");
        }
    ),
    ...generateActionForKey(
        eDangKyHoActionsObj,
        "DANG_KY_HO",
        "CAPNHAT_CHUYENNGANH2_ERROR",
        (payload) => {
            NotifyHelper.Error(payload?.data ?? "Cập nhật chuyên ngành 2 thất bại");
        }
    ),
}
